function getQuantityItemFlags(savingsFormat, hasSampleQuantity, index) {
    // The sample quantity doesn't display "sale". Otherwise, we show the sale text.
    const isSampleQuantity = hasSampleQuantity && index === 0;
    const quantitySavingsIsVisible = savingsFormat !== "hidden" && !isSampleQuantity;
    return {
        quantitySavingsIsVisible,
        isSampleQuantity,
    };
}

export { getQuantityItemFlags };
//# sourceMappingURL=get-quantity-item-flags.mjs.map
